<template>
  <footer id="footer">
    <div class="footerTop">
      <a href="https://www.amway.id/id/privacy" target="_blank">Pernyataan Kerahasiaan</a>
      <span class="dv">|</span>
      <a href="https://www.amway.id/id/terms" target="_blank">Syarat Penggunaan</a>
    </div>
    <div class="footerAddress">
      Tower EightyEight @Kasablanka, 23rd Floor, Jl. Casablanca Raya Kav.88 Jakarta Selatan 12870
      <br />Telepon: <a href="tel:021-57980800">021-57980800</a>
        | Email: <a href="mailto:customer.care@amway.id">customer.care@amway.id</a><br />
      Customer Care: Senin-Minggu, pkl. 08.00-19.00 WIB
    </div>
    <div class="footerCopy">
      ©{{d.getFullYear()}} Amway US. Semua Hak Cipta Adalah Milik Amway.
    </div>
    <div class="footerLogo">
      <img src="../assets/footer-logo-black.png">
    </div>
  </footer>
</template>

<script>
export default {
  data() {
    return {
      d: new Date(),
    };
  },
  methods: {
    newChat() {
      if (!this.$session.get('email')) {
        this.$emit('login');
        return;
      }
      this.$router.push('/consultation');
    },
  },
  mounted() {
  },
};
</script>

<style scoped lang="scss">
footer{
  background-color: #2b2b2b;
  color: #fff;
  color: rgba(255,255,255,.7);
  font-size: 15px;
  padding: 80px 20px 70px;
  text-align: center;
  position: relative;
  font-family: 'Hind Siliguri', sans-serif;
  line-height: 1.3;
  @media (max-width: 680px) {
    padding-left: 16px;
    padding-right: 16px;
  }
  a{
    color: #fff;
    color: rgba(255,255,255,.8);
    &:hover{
      color: #fff;
    }
  }
  .footerTop{
    margin-bottom: 20px;
    .dv{
      margin: 0 20px;
    }
  }
  .footerLogo{
    opacity: .8;
    img{
      max-width: 100%;
    }
  }
  .footerAddress{
    // max-width: 600px;
    margin: 0 auto 20px;
    line-height: 1.4;
  }
  .footerCopy{
    margin-bottom: 40px;
  }
}
</style>
